import { FC, useContext, useEffect, useMemo, useState } from "react";
import { GenericModal } from "components/generic-modal/generic-modal";
import { Button, Grid, makeStyles, StyleRules, Typography, WithStyles, withStyles } from "@material-ui/core";
import { LiteralsContext, withLiterals } from "containers/shared/literals";
import { translate } from "utils/i18n";
import GenericInputText, { TExtraValidation } from "components/generic-input-text";
import styles from "components/generic-input-text/styles";

import { IErrorDomiciliacion } from "containers/domiciliaciones/domiciliacion.alta";
//import Calendar from "containers/shared/calendar";
import { DIAS_SELECCIONABLES_VOLUNTARIA } from "containers/tributos-autonomicos-locales/constants";
import { IDiasCortesia } from "gateways/notificaciones.interfaces";
import { IOrganismo } from "gateways/organismo.interfaces";
import { TributosGateway } from "gateways/tributos.gateway";
import IoC from "contexts/ioc.context";
import { IDatosDomiciliacion, IDatosDomiciliacionExtranjero, IDomiVoluntaria } from "gateways/datos.domiciliacion.interfaces";
import { getAllDatesByYearMonths } from "utils/all-dates-by-months";
import { sanitizeCalendarProps } from "utils/sanitize-calendar-props";
import GenericCheckbox from "components/generic-checkbox";
import usePage from "hooks/page.hook";
import Calendar from "components/calendar/calendar";
import moment from "moment";
import * as ibantools from 'ibantools';
import { validateNif } from "utils/validateNif";
import Term from "components/term";
import { IBaseResponse } from "gateways/base.response.interfaces";
import { IResultadoDomiciliacion } from "gateways/tributos.interfaces";
import { cpuUsage } from "process";
import GenericInputSelect, { TSelect } from "components/generic-input-select";
import { IPais } from "gateways/pais.interface";
import { formatSelectOptions } from "components/generic-sujeto/utils";
import inputText from "components/DUTI/input-text";
import { set } from "lodash";
import { RecibosGateway } from "gateways/recibo.gateway";
import { IFindAllQuery, IRecibo } from "gateways/recibo.interfaces";
import { BLUE } from "containers/shared/colors";
import FullLoading from "components/full-loading";

const useStyleInput = makeStyles(styles);
const custom_styles = (): StyleRules => ({
    calendarFechCargo: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: "1rem",
        alignItems: "flex-start",
        justifyContent: "center"
    },
    itemRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start'
    },
    checkbox:{
        paddingTop: 15
    },
    calendar:{
        flexGrow:1,
        justifyItems: 'center'
    },
    container: {
        marginBottom: 20
    },
    text: {
        paddingBottom: 15
    },
    boldText: {
        paddingBottom: 15,
        fontWeight: 'bold'
    },
    containerDomi: {
        border: 'solid',
        borderWidth: '1px',
        borderRadius: 10,
        borderColor: BLUE,
        padding: '20px 10px 10px 10px',
        marginTop: 20,
        position: 'relative'
    },
    containertextBorder: {
        display: 'flex',        /* Activa Flexbox */
        justifyContent: 'flex-end', /* Alinea el contenido al final (derecha) */
        width: '100%',         /* Asegura que ocupe todo el ancho del Grid */
        position: 'absolute',   /* Posicionamiento absoluto respecto a su contenedor relativo */
        right: 20,            /* Alinea a la derecha */
        top: -20,              /* Alinea al borde superior */
    },
    textBorder: {
        padding: 10,
        color: BLUE,
        backgroundColor: 'white'
    }
})

const EMPTY_DExtranjero_ERR :Record<keyof IDatosDomiciliacionExtranjero, boolean> = {
    bloque:false,
    calle:false,
    cp:false,
    escalera:false,
    km:false,
    numero:false,
    pais:false,
    piso:false,
    poblacion:false,
    portal:false,
    provincia:false,
    puerta:false,
}

const EMPTY_DExtranjero :IDatosDomiciliacionExtranjero = {
    calle: '',cp:'',pais:'',poblacion:''
}
interface IDDomiReciboProps extends WithStyles<typeof custom_styles>{
    open: boolean;
    idRecibo: number;
    organismo: IOrganismo;
    vigencia: string;
    domiciliable: boolean;
    objTrib: {obj: string, ejercicio:number}
    onDomiDone: (recibo: IRecibo) => void;
    onClose: () => void;
}

const DialogDomiciliarRecibo: FC<IDDomiReciboProps> = ({classes, open, idRecibo,organismo, vigencia,domiciliable,objTrib, onDomiDone, onClose}) => {
    const InputClasses = useStyleInput();
    const terms = useContext(LiteralsContext);
    const [pageState,] = usePage();

    const ioc = useContext(IoC);
    const tributosGateway = useMemo(() => ioc.get(TributosGateway) as TributosGateway, [ioc]);
    const recibosGateway = useMemo(() => ioc.get(RecibosGateway) as RecibosGateway, [ioc]);



    const [errors, setErrors] = useState<IErrorDomiciliacion | null>();
    const [iban, setIban] = useState<string|undefined>(undefined);
    const [ibanCode, setIbanCode] = useState<string|undefined>(undefined);

    const [ibanError, setIbanError] = useState(false);
    const [showErrorMSG, setShowErrorMSG] = useState<{show:boolean, term: string|undefined}>({show: false, term: undefined})
    const [nif, setNif] = useState<string|undefined>(undefined);
    const [nifError, setNifError] = useState(false);
    const [nombre, setNombre] = useState<string|undefined>(undefined);
    const [nombreError, setNombreError] = useState(false);
    const [fechaError, setFechaError] = useState(false);
    const [datosExtranjero, setDatosExtranjero] = useState<IDatosDomiciliacionExtranjero>(EMPTY_DExtranjero);
    const [datosExtranjeroErr, setDatosExtranjeroErr] = useState<Record<keyof IDatosDomiciliacionExtranjero, boolean>>(EMPTY_DExtranjero_ERR);
    const [paisesOption, setPaisesOption]= useState<TSelect[]>([])
    const [ idDomi, setIdDomi]= useState<number|null>(null);
    const [datosPrecargados, setDatosPrecargados] = useState(true);
    const [paises, setPaises] = useState<string[]>([]);
    const [loadingPaises,setLoadingPaises]= useState(false)
    const [loading,setLoading]= useState(false)

    // Calendario
    const [fechaPorDefectoDomiVol, setFechaPorDefectoDomiVol]= useState<string| undefined>(undefined)
    const [diasVoluntariaSeleccionados, setDiasVoluntariaSeleccionados] = useState<string[]>([]);
    const [diasVoluntaria, setDiasVoluntaria] = useState<IDiasCortesia>();
    const [fechaPrevistaEnvioVoluntaria, setFechaPrevistaEnvioVoluntaria] = useState<string | undefined>();

    const showDatosExtranjero = useMemo(() => {
        // console.log('memo ', iban, ibanError)
        if(iban && iban.length>=2){// !ibanError){
            const ibanCode = iban.slice(0, 2); 
            console.log(paises, paises.includes(ibanCode))
            setIbanCode(ibanCode)
            return paises.includes(ibanCode)
        }
        setDatosExtranjeroErr(EMPTY_DExtranjero_ERR)
        setDatosExtranjero(EMPTY_DExtranjero)

        return false
    },[iban, ibanError])

    const handleCheckErrResultados = (result: IBaseResponse<IResultadoDomiciliacion>) => {
        if(result.estado === ''){ return undefined}
        switch (result.estado) {
            case 'iban':
                return 'El código IBAN no es válido'
            case 'same-iban':
                return 'El código IBAN es el mismo'
            case 'dni':
                return 'El DNI introducido no es válido'
            case 'nie':
                return 'El NIE introducido no es válido'
            case 'cif':
                return 'El CIF introducido no es válido'
            case 'errorDocumento':
                return'El documento introducido no es válido'
            default:
                return 'No ha sido posible domiciliar el objeto tributario'
        }
    }


    const validateDatosExtranjero = async (datos: IDatosDomiciliacionExtranjero) => {
        if(!showDatosExtranjero){
            return true
        }
        //Comprobar datos Required
        if( datos.pais === '' || datos.calle === ''|| datos.cp === ''
            || datos.poblacion === ''
        ){
            setDatosExtranjeroErr( curr =>({
                ...curr,
                pais: datos.pais === '',
                cp:datos.cp === '',
                calle:datos.calle === '',
                poblacion: datos.poblacion === ''
            }))
            return false
        }

        // Comprobar datos extranjero
        const result = await tributosGateway.validarPreExtranjero({ // validarPreGB({
            idRecibos: [idRecibo],
            iban: iban ?? '',
        });
        let term: string | undefined = undefined
        if(!result.ok){
            term = handleCheckErrResultados(result) 
        }   

        setShowErrorMSG(curr => ({...curr, show: !result.ok, term: term}))
        return result.ok
    }


    const handleOnDomi = async() => {
        setLoading(true)
        if(
            (ibanError || !iban || iban === '') 
            || (nifError||!nif || nif === '')
            || (nombreError ||!nombre || nombre === '')
            || (!fechaPrevistaEnvioVoluntaria || fechaPrevistaEnvioVoluntaria === '')
            || !await validateDatosExtranjero(datosExtranjero)
        ){
            //console.log('with errors')
            setIbanError(curr => !iban || iban === '')
            setNifError(curr => !nif || nif === '')
            setNombreError(curr => !nombre || nombre === '')
            setFechaError(curr => !fechaPrevistaEnvioVoluntaria || fechaPrevistaEnvioVoluntaria === '')

        } else {
            // Domiciliar 
            const infoDomi: IDatosDomiciliacion = {
                idRecibos: [idRecibo],
                iban: iban,
                nif: nif,
                nombre: nombre,
                domiciliables: domiciliable,
                esIbanExtranjero: showDatosExtranjero,
                datosDireccionExtranjero: showDatosExtranjero? datosExtranjero : undefined,
                fechaPrevistaEnvioVoluntaria: fechaPrevistaEnvioVoluntaria,
                pagoCarta: false
            }
            //console.log(' a domiciliar ', infoDomi)
            
            const response = await tributosGateway.domiciliar(infoDomi)
            
            if(response.ok){ 
                const query: IFindAllQuery ={
                    objTributario: objTrib.obj,
                    ejercicios: [objTrib.ejercicio]
                };
                // console.log('query ', query)
                const infoRecibo = await recibosGateway.findAll(query)
                //console.log('info ', infoRecibo)
                onDomiDone(infoRecibo[0]);
            } else {
                const term = handleCheckErrResultados(response)
                setShowErrorMSG(curr => ({...curr, show: !response.ok, term: term}))
            }
            
        }
        setLoading(false)
    }

    // Datos Domiciliacion
    const precargarDatos = async () => {
        if (pageState.jwp != null) {
            setNombre(pageState.jwp.fullname);
            setNif(pageState.jwp.nif);
        }
    }
    const handleChange = (val: boolean) => {
        if (val) {
            precargarDatos();
        } else {
            setNombre(undefined);
            setNif(undefined);
        }
        setDatosPrecargados(val);
    };

    const extraValidateNIF = (nif: string) => {
        const isValid = validateNif(nif)
        setNifError(!isValid)
        const result: TExtraValidation={ 
            error: isValid ? false: true, 
            error_msg: 'nif_error_format',
            componentIG: 'GenericComponents'
        }
        return result
    }

    const extraValidateIBAN = (iban: string) => {
        const isValid = ibantools.isValidIBAN(iban)
        setNifError(!isValid)
        const result: TExtraValidation={ 
            error: isValid ? false: true, 
            error_msg: 'El código IBAN no es válido',
            componentIG:"Domiciliaciones"
        }
        return result
    }

    const extraValidateCP = (cp:string) => {
        return { 
            error: cp.length>10, 
            error_msg: 'err_maxLength',
        }
    }

    // Calendar
    const setDiasSeleccionados = (fechas: string[]) => {
        setDiasVoluntariaSeleccionados(fechas)
        setFechaError(false)
        if(fechas.length>0){
            setFechaPrevistaEnvioVoluntaria(fechas[0])
        } else {
            setFechaPrevistaEnvioVoluntaria(undefined)
        }
    }

    useEffect(() => {
        (async() => {
            // inicialización datos
            if(open && idRecibo){
                const fechaDefaultDomi = await tributosGateway.getFechaPorDefectoDomiVoluntaria(idRecibo, vigencia)

                // 1.Obtener fechas del calendario => extracción Funcionalidad dias-voluntaria.hook
                // 1.1 Creamos array donde incluiremos los meses disponibles para la domiciliación voluntaria y obtenemos las fechas para la domi. vol. y el idSujeto
                let availableYearMonth: { year: number, months: number[] }[] = [];
                const fechaDomiciliacionIncompatible: string | null = await tributosGateway.getFechaDomiciliacionIncompatible(organismo.codigo);
                let result: IDomiVoluntaria | boolean = await tributosGateway.getFechasVoluntaria(idRecibo, idDomi );

                if (typeof result === "boolean") return;
                /**
                * 1.2 Obtenemos los años y meses en los cuales se puede realizar la domiciliación voluntaria
                * La llamada de la cual obtenemos las fechas únicamente nos devuelve las fechas en las cuales se puede realizar la domi. vol.
                * pero no las fechas deshabilitadas, de este modo obtendremos las fechas en las cuales se puede domiciliar voluntariamente y las fechas
                * en las cuales está deshabilitada la domiciliación voluntaria
                */
                for (let dia of result.fechasVoluntaria) {
                    let availableYear = availableYearMonth.find(({ year }) => year === new Date(dia).getFullYear());
                    if (!availableYear) availableYearMonth.push({ year: new Date(dia).getFullYear(), months: [new Date(dia).getMonth()] });
                    else if (!availableYear.months.includes(new Date(dia).getMonth())) availableYear.months.push(new Date(dia).getMonth());
                }
                // 1.3 Una vez tenemos los meses por año en los cuales se puede realizar la domi. vol. obtendremos los días correspondientes a cada mes
                const daysArray: string[] = getAllDatesByYearMonths(availableYearMonth);
                // 1.4 Seteamos los días que son seleccionables que nos han llegado de BD y los días que no figuran en el json de DB los ponemos como `selecionable: false`
                // ** Si se le pasa fecha por defecto seleccionada se le pone `seleccionada: true` => fechaDefaultDomi
                let voluntaria: IDiasCortesia = sanitizeCalendarProps(result, daysArray, fechaDomiciliacionIncompatible, 1);
    
                precargarDatos();
                setFechaPorDefectoDomiVol(fechaDefaultDomi ? moment(fechaDefaultDomi).format('YYYY-MM-DD') : undefined);
                setDiasVoluntaria(voluntaria);
            }

            if(paises.length === 0){
                const result = await tributosGateway.paisesDomiDirObligada()
                setPaises(result)
            }

            if(!open){
                // Resetear datos
                setDiasVoluntariaSeleccionados([])
                setFechaPrevistaEnvioVoluntaria(undefined)
                setFechaPorDefectoDomiVol(undefined)
                setDiasVoluntaria(undefined)
                setIbanError(false)
                setFechaError(false)
                setNifError(false)
                setDatosExtranjeroErr(EMPTY_DExtranjero_ERR)
            }
        })()
    }, [idRecibo, open])

    useEffect(() => {
        (async() => {
            if(ibanCode && showDatosExtranjero){
                setLoadingPaises(true)
                const paisByIso: IPais[] = await tributosGateway.postPaisByIso([ibanCode])
                const paisesOrdenAlfabetico = paisByIso.sort((elementA, elementB) => {
                    return elementA.nombre !== elementB.nombre
                        ? elementA.nombre > elementB.nombre
                            ? 1
                            : -1
                        : 0;
                });
                setLoadingPaises(false)
                setPaisesOption(formatSelectOptions<IPais>('idPais','nombre',paisesOrdenAlfabetico));
            }
        })()
        
    },[ibanCode, showDatosExtranjero])


    return(
        <GenericModal
            open={open}
            onClose={onClose}
            title={'DialogDomiciliarRecibo'}
            componentTitleTranslation={"Domiciliaciones"}
            isTitleHtml={false}
            maxWidth={'lg'}
            customAction={
                () => <Button onClick={handleOnDomi} variant="contained" color="primary">
                        {translate("Domiciliaciones","Domiciliar", terms)}
                    </Button>
            }
        >
            <div className={classes.container}>
                <FullLoading loading={loading}/>
                <Typography className={classes.boldText}>{translate("Domiciliaciones", "aviso_pagoACuentaDomi_reciboNoDomi",terms)}</Typography>
                <Typography className={classes.text}>{translate("Domiciliaciones", "pagoACuentaDomi_domiciliar_ahora",terms)}</Typography>
                <Grid container direction="column" className={classes.containerDomi}>
                    <Grid item className={classes.containertextBorder}>
                        <Typography className={classes.textBorder}>
                            {translate("Domiciliaciones","datosDomi", terms).toUpperCase()}
                        </Typography>
                    </Grid>
                    {showErrorMSG && showErrorMSG.term &&
                        <Grid item>
                            <Typography>{translate('Domiciliaciones', showErrorMSG.term,terms)}</Typography>
                        </Grid>
                    }
                    <Grid item>
                        <GenericInputText
                            labelTerm="IBAN "
                            className={InputClasses.input545}
                            required
                            variant='outlined'
                            margin='dense'
                            value={iban}
                            error={ibanError}
                            errorMsgExterno={ibanError && errors
                                ? errors.iban
                                : translate('Domiciliaciones','LongitudIBAN',terms)}
                            onChangeValue={(val:string, err: boolean) =>{ 
                                setIban(val.toUpperCase().replace(/\s+/g, ''))
                                console.log('set iban error 1', err)
                                setIbanError(err)
                            }}
                            extraValidation={extraValidateIBAN}
                        />
                    </Grid>
                    <Grid item className={classes.itemRow}>
                        <GenericInputText
                            variant='outlined'
                            margin='dense'
                            labelTerm={'NIF titular required'}
                            componentIG={'Domiciliaciones'}
                            value={nif}
                            error={nifError}
                            errorMsgExterno={nifError ? errors?.nif : undefined}
                            disabled={datosPrecargados}
                            required={!datosPrecargados}
                            onChangeValue={(val: string, err: boolean) => {
                                setNif(val);
                                setNifError(err);
                            }}
                            extraValidation={extraValidateNIF}
                        />
                        <GenericInputText
                            variant='outlined'
                            margin='dense'
                            labelTerm={'Nombre titular required'}
                            componentIG={'Domiciliaciones'}
                            value={nombre}
                            error={nombreError}
                            disabled={datosPrecargados}
                            required={!datosPrecargados}
                            onChangeValue={(val: string, err:boolean) => {
                                setNombre(val)
                                setNombreError(err)
                            }}
                        />
                        <GenericCheckbox
                            labelTerm={'Datos titular'}
                            componentIG={'Domiciliaciones'}
                            value={datosPrecargados}
                            onChangeValue={handleChange}
                            className={classes.checkbox}
                        />
                    </Grid>
                    {showDatosExtranjero && 
                        <Grid item container direction="row">
                            {/*Pais */}
                            <GenericInputSelect
                                key='tipoDerecho'
                                componentIG='Tramites'
                                labelTerm='Pais'
                                value={ paisesOption.find(p => p.id ===datosExtranjero.pais) }
                                options={paisesOption}
                                disabled={paisesOption.length===0 }
                                required
                                onChangeValue={(val: TSelect|undefined, err: boolean) => {
                                    const paisID = val ? val.id : ''
                                    setDatosExtranjero(curr => (curr ? {...curr, pais: paisID}: {poblacion: paisID} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, poblacion:err}))
                                }}
                                error={datosExtranjeroErr.pais}
                                loading={loadingPaises}
                            />

                            {/* Población */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'poblacion'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.poblacion}
                                error={datosExtranjeroErr.poblacion}
                                // errorMsgExterno={}
                                required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, poblacion: val}: {poblacion: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, poblacion:err}))
                                }}
                            />
                            {/* Dirección */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Dirección'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.calle}
                                error={datosExtranjeroErr.calle}
                                className={InputClasses.input545}
                                // errorMsgExterno={}
                                required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    const calleVal= val && val !== '' ? val.toUpperCase(): ''
                                    setDatosExtranjero(curr => (curr ? {...curr, calle: calleVal}: {calle: calleVal} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, calle:err}))
                                }}
                            />
                            {/* Código Postal */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'CodigoPostal'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.cp}
                                error={datosExtranjeroErr.cp}
                                // errorMsgExterno={}
                                required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    const cpVal= val && val !== '' ? val.toUpperCase(): ''
                                    setDatosExtranjero(curr => (curr ? {...curr, cp: cpVal}: {cp: cpVal} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, cp:err}))
                                }}
                                extraValidation={extraValidateCP}
                            />
                            {/* Número */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Numero'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.numero}
                                error={datosExtranjeroErr.numero}
                                className={InputClasses.input100}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    const numVal= val && val !== '' ? val.toUpperCase(): ''
                                    setDatosExtranjero(curr => (curr ? {...curr, numero: numVal}: {numero: numVal} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, numero:err}))
                                }}
                            />
                            {/* Kilómetro */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'km'}
                                componentIG={'Domiciliaciones'}
                                value={datosExtranjero?.km}
                                error={datosExtranjeroErr.km}
                                className={InputClasses.input100}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, km: val}: {km: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, km:err}))
                                }}
                            />
                            {/* Bloque */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Bloque'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.bloque}
                                error={datosExtranjeroErr.bloque}
                                className={InputClasses.input100}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, bloque: val}: {bloque: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, bloque:err}))
                                }}
                            />
                            {/* Escalera */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Escalera'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.escalera}
                                error={datosExtranjeroErr.escalera}
                                className={InputClasses.input100}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, escalera: val}: {escalera: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, escalera:err}))
                                }}
                            />
                            {/* Portal */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Portal'}
                                componentIG={'Domiciliacones'}
                                value={datosExtranjero?.portal}
                                className={InputClasses.input100}
                                //error={datosExtranjeroErr.portal}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, portal: val}: {portal: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, portal:err}))
                                }}
                            />

                            {/* Piso */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Piso'}
                                componentIG={'Tramites'}
                                value={datosExtranjero?.piso}
                                className={InputClasses.input100}
                                //error={datosExtranjeroErr.piso}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, piso: val}: {piso: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, piso:err}))
                                }}
                            />
                            {/* Puerta */}
                            <GenericInputText
                                variant='outlined'
                                margin='dense'
                                labelTerm={'Puerta'}
                                componentIG={'Domiciliaciones'}
                                value={datosExtranjero?.puerta}
                                className={InputClasses.input100}
                                //error={datosExtranjeroErr.puerta}
                                // errorMsgExterno={}
                                //required={true}
                                onChangeValue={(val: string, err: boolean) => {
                                    setDatosExtranjero(curr => (curr ? {...curr, puerta: val}: {puerta: val} as IDatosDomiciliacionExtranjero ))
                                    setDatosExtranjeroErr( curr =>({...curr, puerta:err}))
                                }}
                            />

                        </Grid>
                    }
                    <Grid item>
                        {fechaError && <Typography color="error">
                            {translate("Domiciliaciones","requiredFechaPrevistaDomi",terms)}
                        </Typography>}
                        { !diasVoluntaria || diasVoluntaria.dias.length < 1
                        ?
                            <div >
                                {translate('Domiciliaciones','Días voluntaria no disponibles',terms)}
                            </div>
                        :
                            <div className={classes.itemRow}>
                                <Calendar 
                                    initialDiasCortesia={diasVoluntaria.dias} 
                                    fechaPorDefecto={fechaPorDefectoDomiVol}
                                    selectedDays={diasVoluntariaSeleccionados} 
                                    setSelectedDays={setDiasSeleccionados} 
                                    legend={{
                                        titleSeleccionado: translate("Domiciliaciones","Fecha prevista domiciliación voluntaria",terms, [fechaPrevistaEnvioVoluntaria ? moment(fechaPrevistaEnvioVoluntaria).format('DD/MM/YYYY') : '']),
                                        titleHabilitados: translate("Domiciliaciones","Leyenda días habilitados domiciliación voluntaria",terms),
                                        titleDeshabilitado: translate("Domiciliaciones","Leyenda días deshabilitados domiciliación voluntaria",terms),
                                    }} 
                                    noDiasCortesiaText={translate("Domiciliaciones","Días voluntaria no disponibles",terms)}   
                                    limiteDiasSeleccionables={DIAS_SELECCIONABLES_VOLUNTARIA}                             
                                    />
                            </div>
                        }
                    </Grid>
                </Grid>

            </div>
        </GenericModal>
    )
}

export default  withLiterals(["Domiciliaciones"])(withStyles(custom_styles)(DialogDomiciliarRecibo))

